const SPOTS = [
  { left: '6%', top: '18%' },
  { left: '14%', top: '66%' },
  { left: '26%', top: '36%' },
  { left: '40%', top: '80%' },
  { left: '52%', top: '12%' },
  { left: '64%', top: '58%' },
  { left: '76%', top: '26%' },
  { left: '88%', top: '72%' },
  { left: '92%', top: '14%' },
  { left: '34%', top: '60%' },
];

export default function Flakes() {
  return (
    <div className="flakes" aria-hidden="true">
      {SPOTS.map((s, i) => (
        <span key={i} className="flake" style={{ left: s.left, top: s.top }} />
      ))}
    </div>
  );
}
